export type SupportedLanguage = 'en' | 'es';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'es'];

const STORAGE_KEY = 'kiosk_language';

export function normalizeLanguage(input: unknown): SupportedLanguage {
  const raw = String(input ?? '').trim().toLowerCase();
  if (raw.startsWith('es')) return 'es';
  return 'en';
}

export function getStoredLanguage(): SupportedLanguage {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  return normalizeLanguage(window.localStorage.getItem(STORAGE_KEY));
}

export function setStoredLanguage(lang: SupportedLanguage): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, lang);
}

